module.exports = __webpack_public_path__ + "img/elxz2.14a4bcf4.jpg";